import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import './HomePage.css'; 
import image1 from '../Images/1.jpg';
import logo from '../Images/logo1.png';

function HomePage() {
  return (
    <div className="container">
      <div className="text-section">
        
        {/* Logo and DUSKY text */}
        <div className="logo-container">
          <img src={logo} alt="Dusky Tech Logo" className="logo-img" />
          <h2 className="logo-text">DUSKY</h2>
        </div>

        {/* Animated text */}
        <div className="text-content">
          <TypeAnimation
            sequence={[
              'GREAT PRODUCT', 1000,
              'IS BUILT BY', 1000,
              'GREAT TEAMS', 1000,
            ]}
            speed={50}
            repeat={Infinity}
            wrapper="h1"
          />
        </div>
      </div>

      {/* Image section */}
      <div className="image-section">
        <img src={image1} alt="Team Image" className="team-image" />
      </div>
    </div>
  );
}

export default HomePage;
